module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel05_770_280_ja-7e9ed6f369fe9dd113bfd015d1113d1e.jpg";